(() => {
  const root = document.querySelector('.product-info');
  if (!root) return;

  // Keep the required-option validation in the storefront language.
  const translateValidation = (scope) => {
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (node.nodeValue.trim() === '목록에서 항목을 선택하세요.') {
        node.nodeValue = node.nodeValue.replace('목록에서 항목을 선택하세요.', 'Please select an option from the list.');
      }
    });
  };
  translateValidation(document.body);
  new MutationObserver((records) => records.forEach((record) => {
    if (record.type === 'characterData' && record.target.nodeValue.trim() === '목록에서 항목을 선택하세요.') {
      record.target.nodeValue = 'Please select an option from the list.';
    }
    record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.nodeValue.trim() === '목록에서 항목을 선택하세요.') {
          node.nodeValue = 'Please select an option from the list.';
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        translateValidation(node);
      }
    });
  })).observe(document.body, { childList: true, characterData: true, subtree: true });
  const update = () => {
    const panel = root.querySelector('#bcpo');
    if (!panel) return;
    const fields = Array.from(panel.querySelectorAll('select[name^="properties["]'));
    fields.forEach((select) => {
      const placeholder = select.options[0];
      if (placeholder && placeholder.value === '' && placeholder.disabled && placeholder.textContent !== 'Select') {
        placeholder.textContent = 'Select';
      }
    });
    const sides = ['Left', 'Right'].map(side => fields.filter(s => s.name.startsWith('properties[' + side + ' ')));
    if (sides.every(side => side.length > 0)) {
      panel.classList.add('kpop2-eye-layout');
      sides.forEach((selects, sideIndex) => {
        const side = sideIndex === 0 ? 'Left' : 'Right';
        let heading = panel.querySelector('[data-eye-heading="' + side + '"]');
        if (!heading) {
          heading = document.createElement('div');
          heading.className = 'kpop2-eye-heading';
          heading.dataset.eyeHeading = side;
          heading.textContent = side + ' eye';
          heading.style.setProperty('--eye-col', sideIndex + 1);
          heading.style.setProperty('--eye-desktop-col', sideIndex * 2 + 1);
          panel.insertBefore(heading, selects[0].closest('.selector-wrapper'));
        }
        selects.forEach((select, index) => {
          const wrapper = select.closest('.selector-wrapper');
          const title = wrapper?.querySelector('.bcpo-title');
          if (!wrapper || !title) return;
          const original = select.name.slice(11, -1);
          const text = original.replace(/^(Left|Right) /, '').replace(' (Buy 1Box)', ' · Buy').replace(' (Free 1Box)', ' · Free');
          if (title.textContent !== text) title.textContent = text;
          title.title = original;
          select.setAttribute('aria-label', original);
          select.removeAttribute('aria-labelledby');
          wrapper.classList.add('kpop2-eye-field');
          wrapper.style.setProperty('--eye-col', sideIndex + 1);
          wrapper.style.setProperty('--eye-row', index + 2);
          wrapper.style.setProperty('--eye-desktop-col', sideIndex * 2 + index % 2 + 1);
          wrapper.style.setProperty('--eye-desktop-row', Math.floor(index / 2) + 2);
        });
      });
    }
    fields.filter(select => select.name === 'properties[Made to order]').forEach(select => {
      const choices = Array.from(select.options).filter(option => option.value && !option.disabled);
      const wrapper = select.closest('.selector-wrapper');
      if (choices.length !== 1 || !wrapper) return;
      if (select.value !== choices[0].value) {
        select.value = choices[0].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (!select.value) return;
      let display = wrapper.querySelector('.kpop2-production-radio');
      if (!display) {
        display = document.createElement('label');
        display.className = 'kpop2-production-radio';
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.checked = true;
        radio.defaultChecked = true;
        const text = document.createElement('span');
        display.append(radio, text);
        select.parentElement.append(display);
      }
      const text = display.querySelector('span');
      if (text.textContent !== choices[0].textContent) text.textContent = choices[0].textContent;
      wrapper.classList.add('kpop2-production-single');
    });
  };
  update();
  new MutationObserver(update).observe(root, { childList: true, subtree: true });
  // BCPO renders conditional children, while its empty grid wrappers stay visible.
  // Keep one enabled paid/free field in the layout and canonical order property names.
  const repairConditionalPowerFields = () => {
    root.querySelectorAll('#bcpo .selector-wrapper[data-unique]').forEach((wrapper) => {
      const select = wrapper.querySelector('select[name^="properties[Power (Free 1Box)"]');
      const label = wrapper.querySelector('.bcpo-label');
      if (!select || !label) return;
      const hidden = select.disabled && label.style.display === 'none';
      if (hidden && wrapper.style.display !== 'none') {
        wrapper.style.setProperty('display', 'none', 'important');
      } else if (!hidden && wrapper.style.display === 'none') {
        wrapper.style.removeProperty('display');
      }
      if (select.name !== 'properties[Power (Free 1Box)]') {
        select.name = 'properties[Power (Free 1Box)]';
      }
    });
  };
  repairConditionalPowerFields();
  root.addEventListener('change', repairConditionalPowerFields);
  new MutationObserver(repairConditionalPowerFields).observe(root, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'disabled']
  });

})();